import React from 'react';

import { MissingData } from './TechnicalMessage.styles';
import { TextMediumSmall } from 'lib/common/text';
import { Icon } from 'theme/icons/Icon';

export const TechnicalMessage = ({ children, isError }) => (
    <MissingData isError={isError}>
        <div style={{ paddingLeft: '12px' }}>
            <Icon type="dataMissing" height={14} />
        </div>
        <div style={{ paddingLeft: '9px' }}>
            <TextMediumSmall bold color="black">
                {children}
            </TextMediumSmall>
        </div>
    </MissingData>
);

TechnicalMessage.displayName = 'TechnicalMessage';
